import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "bootstrap-icons/font/bootstrap-icons.css";
import { AuthProvider } from "./AcuvisorCustomerApp/context/AuthContext";
import clearOutdatedLocalStorage from "./Utilities/clearOutdatedLocalStorage";

// Clear outdated local storage items
clearOutdatedLocalStorage();

if (process.env.REACT_APP_STAGE_ENV === "") {
  // Overwrite console methods with an empty function
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
  // You can still leave console.warn and console.error active
  // if you want to see critical alerts in production.
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <AuthProvider>
      <App />
    </AuthProvider>
  </BrowserRouter>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
